import {
  selectCommentoCorsa,
  selectDescrizioneAvvenimento,
  selectDescrizionePremio,
  selectPista,
  selectPronostico,
  selectTipoCorsa,
} from 'features/ippica/selectors';
import { useGetLabelByKey, useGetLabelsByKeys } from 'hooks/useLingUI';

import { Content as Accordion } from '@radix-ui/react-accordion';
import { IppicaInfoListItem } from '../../ippicaInfoListItem';
import React from 'react';
import styles from './IppicaHeaderInfoAccordionContent.module.scss';
import { useTypedSelector } from 'lib/centralStore';

// eslint-disable-next-line react/display-name
export const IppicaHeaderInfoAccordionContent = React.forwardRef<HTMLDivElement>(({}, forwardedRef) => {
  const labelPronostico = useGetLabelByKey('pronostico');
  const labelPremio = useGetLabelByKey('premio');
  const labelTipo = useGetLabelByKey('tipo');
  const labelPista = useGetLabelsByKeys(['pista']);
  // const labelstatoTerreno = useGetLabelByKey('stato-terreno');
  const labelDescrizione = useGetLabelByKey('descrizione');
  const pronostico = useTypedSelector(selectPronostico);
  const tipoCorsa = useTypedSelector(selectTipoCorsa);
  const descrizionePremio = useTypedSelector(selectDescrizionePremio);
  const descrizioneAvvenimento = useTypedSelector(selectDescrizioneAvvenimento);
  const pista = useTypedSelector(selectPista);
  const commentoCorsa = useTypedSelector(selectCommentoCorsa);

  return (
    <Accordion ref={forwardedRef} className={styles.container}>
      <div className={styles.wrapper}>
        <ul className={styles.list}>
          <li className={styles.title}>{labelPronostico}</li>
          {!!pronostico?.length
            ? pronostico.map((item: { numero: number; nome: string }, index) => {
                return (
                  <React.Fragment key={item.nome + '_' + index}>
                    <IppicaInfoListItem className={styles.item} textType={'medium'}>
                      <span className={styles.num}>{item.numero}</span> {item.nome}
                    </IppicaInfoListItem>
                  </React.Fragment>
                );
              })
            : '-'}
        </ul>
        <div className={styles.listsContainer}>
          <ul className={styles.infoList}>
            <IppicaInfoListItem className={styles.infoListItem} title={labelPremio} textType={'small'}>
              {descrizionePremio ? descrizionePremio : descrizioneAvvenimento || ''}
            </IppicaInfoListItem>
            <IppicaInfoListItem className={styles.infoListItem} title={labelTipo} textType={'small'}>
              {tipoCorsa ? tipoCorsa : '-'}
            </IppicaInfoListItem>
            <IppicaInfoListItem className={styles.infoListItem} title={labelPista[0]} textType={'small'}>
              {pista ? pista : '-'}
            </IppicaInfoListItem>
            {/* TODO MANCA DA DB
              <IppicaInfoListItem className={styles.infoListItem} title={labelstatoTerreno} textType={'small'}>
                {statoTerreno ? statoTerreno : '-'}
              </IppicaInfoListItem>
            */}
          </ul>
          <div className={styles.descrContainer}>
            <span className={styles.title}>{labelDescrizione}</span>
            <p className={styles.paragraph}>{commentoCorsa ? commentoCorsa : '-'}</p>
          </div>
        </div>
      </div>
    </Accordion>
  );
});
